const ASSETS = {
  logo: require('./icons/logo.svg').default,
  arrowRightWhite: require('./icons/arrow-right-white.svg').default,
  hero: require('./img/hero.png'),
  hero2x: require('./img/hero2x.png'),
  her02: require('./img/hero2.png'),
  appStore: require('./icons/app-store.svg').default,
  playStore: require('./icons/playstore.svg').default,
  '1': require('./img/1.png'),
  '2': require('./img/2.png'),
  '3': require('./img/3.png'),
  '4': require('./img/4.png'),
  lady: require('./img/lady.png'),
  story1: require('./img/story1.png'),
  story2: require('./img/story2.png'),
  story3: require('./img/story3.png'),
  arrowRightBlue: require('./icons/arrow-right-blue.svg').default,
  mail: require('./icons/email.svg').default,
  vide: require('./img/video.png'),
  lawyer: require('./img/lawyer.png'),
  quotes: require('./icons/quotes.svg').default,
  chevronRight: require('./icons/chevron-right.svg').default,
  plus: require('./icons/plus.svg').default,
  phone: require('./icons/phone.svg').default,
  hero3: require('./img/hero3.png'),
  hammer: require('./icons/hammer.svg').default,
  setting: require('./icons/setting.svg').default,
  handshake: require('./icons/handshake.svg').default,
  founder: require('./img/founder.png'),
  call: require('./icons/call.svg').default,
  CEO: require('./img/CEO.png'),
  sabzwari: require('./img/sabzwari.png'),
  asif_mehmood: require('./img/aisf-mehmood.png'),
  ammaz_sajid: require('./img/ammaz_sajid.png'),
  abdulhanan: require('./img/abdulhanan.png'),
  zeeshan_tariq: require('./img/zeeshan_tariq.png'),
  usman_hanjra: require('./img/usman_hanjra.png'),
  shoaib: require('./img/shoaib.png'),
  rao_farhan: require('./img/rao_farhan.png'),
  rana_suchar: require('./img/rana_suchar.png'),
  hassan_samra: require('./img/hassan_samra.png'),
  instagram: require('./icons/instagram.svg').default,
  facebook: require('./icons/facebook.svg').default,
  twitter: require('./icons/twitter.svg').default,
  linkedIn: require('./img/linkedIn.png'),
};

export default ASSETS;
